import React, { useState } from "react";
import { Modal, Button } from "antd";
import AddPhotoForm from "../Galery/AddPhotoForm";

const AddPhotoModal = ({ onPhotoAdded }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const handleSuccess = (newPhoto) => {
    if (onPhotoAdded) onPhotoAdded(newPhoto);
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        color={"cyan"}
        variant="outlined"
        onClick={showModal}>
        + Նկար
      </Button>
      <Modal
        title="Բեռնել Նկար"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        destroyOnHidden
      >
        <AddPhotoForm onSuccess={handleSuccess} onClose={handleCancel} />
      </Modal>
    </>
  );
};

export default AddPhotoModal;
